import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HelpAudience } from '../../core/models/help-content.model';

/**
 * Trackt Suchen ohne Treffer. Fire-and-forget: Fehler werden geschluckt, ein
 * Search-Miss-Tracking ist nichts, was den Nutzer-Flow beeinflussen darf.
 * Throttled clientseitig auf 1 POST pro Query+Audience pro Session.
 */
@Injectable({ providedIn: 'root' })
export class HelpSearchMissService {
  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly seen = new Set<string>();

  record(audience: HelpAudience, query: string) {
    if (!isPlatformBrowser(this.platformId)) return;
    const q = (query ?? '').trim().toLowerCase();
    if (q.length < 3) return;
    const key = `${audience}:${q}`;
    if (this.seen.has(key)) return;
    this.seen.add(key);

    this.http
      .post('/api/help/search-miss', { query: q, audience })
      .subscribe({ error: () => {} });
  }
}
